/* global femcare, axios */

femcare.quiz.nps = {
    init: async function() {
        this.$popup = $('.survey-popup');

        if (this.$popup.length) {
            this.$question = $('.survey-popup__question');
            this.$answers = $('.survey-popup__answer');
            this.$completedMessage = $('.survey-popup__completed');
            this.$closeButton = $('.survey-popup__close');

            const completionCookieName = this.$popup.data('completionCookieName');
            if (this.readCookie(completionCookieName)) {
                return;
            }

            const timerCookieName = completionCookieName + '-t';
            this.antiforgeryToken = await femcare.form.protection.provideCSRFToken();
            this.initEventHandlers(completionCookieName, timerCookieName);
            this.initTimer(timerCookieName);
        }
    },

    initTimer: function(timerCookieName) {
        const startDelaySeconds = parseInt(this.$popup.data('startDelaySeconds'), 10);
        const timerCookie = this.readCookie(timerCookieName);
        let elapsedSeconds = (timerCookie && parseInt(timerCookie, 10)) || 0;
        const intervalNumber = 1000;

        const interval = setInterval(() => {
            elapsedSeconds += 1;

            if (elapsedSeconds >= startDelaySeconds) {
                clearInterval(interval);
                this.$popup.show();

                return;
            }

            this.writeCookie(timerCookieName, elapsedSeconds, null);
        }, intervalNumber);
    },

    initEventHandlers: function(completionCookieName, timerCookieName) {
        const completionCookieExpiryDays = parseInt(this.$popup.data('completionCookieExpiryDays'), 10);
        const expiryDate = new Date();
        expiryDate.setDate(expiryDate.getDate() + completionCookieExpiryDays);

        this.$answers.on('click', (e) => {
            axios({
                method: 'POST',
                url: this.$popup.data('postUrl'),
                headers: {
                    'Content-Type': 'application/json',
                    'X-Request-Verification-Token': this.antiforgeryToken,
                    'X-Requested-With': 'XMLHttpRequest'
                },
                data: {
                    quizId: this.$popup.data('surveyId'),
                    answers: [$(e.currentTarget).data('value')]
                }
            });

            this.$closeButton.hide();
            this.$question.hide();
            this.$answers.hide();
            this.$completedMessage.show();

            this.writeCookie(completionCookieName, 'true', expiryDate);
            this.removeCookie(timerCookieName);

            setTimeout(() => {
                this.$popup.hide();
            }, 2000);
        });

        this.$closeButton.click(() => {
            this.$popup.hide();
            this.writeCookie(completionCookieName, 'true', expiryDate);
            this.removeCookie(timerCookieName);
        });
    },

    readCookie: function(cookieName) {
        const match = document.cookie.match(new RegExp('(^|;\\s*)(' + cookieName + ')=([^;]*)'));

        return match ? decodeURIComponent(match[3]) : null;
    },

    writeCookie: function(cookieName, value, expires) {
        const cookie = [];
        cookie.push(cookieName + '=' + encodeURIComponent(value));
        if (expires) {
            cookie.push('expires=' + new Date(expires).toGMTString());
        }
        cookie.push('path=/');
        document.cookie = cookie.join('; ');
    },

    removeCookie: function(cookieName) {
        this.writeCookie(cookieName, '', Date.now() - 1000);
    }
};
